// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"0187f47b15c4955da94a","147":"1bbf3edc01e33e29bc1f","251":"d611824d8c0be29ab804","265":"88cbfd9a071139a17262","352":"6ff888b4e0d4c7dddc74"}[chunkId] + ".js";
};